document.addEventListener('click', function (e) {
    if (e.target.closest('.no-close')) return
    if (e.target.closest('.mobile-no-close')) {
        if (matchMedia('(max-width: 767px)').matches) {
            return
        }
    }

    const allActive = document.querySelectorAll('[data-dropdown].active')
    const trigger = e.target.closest('[data-dropdown-trigger]')
    const allTriggers = document.querySelectorAll('[data-dropdown-trigger]')

    // Click on trigger
    if (trigger) {
        const id = trigger.getAttribute('data-dropdown-trigger')
        const dropdown = document.querySelector(`[data-dropdown="${id}"]`)

        // If this dropdown is already open → close and abort
        if (dropdown.classList.contains('active')) {
            dropdown.classList.remove('active')
            trigger.classList.remove('active')
            return
        }

        // Otherwise: close all and open this one
        allActive.forEach((el) => el.classList.remove('active'))
        dropdown.classList.add('active')
        trigger.classList.add('active')
        return
    }

    // Click somewhere else → close everything
    allActive.forEach((el) => el.classList.remove('active'))
    allTriggers.forEach((el) => el.classList.remove('active'))
})
